( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '#start-form-btn' ).on( 'click', function() {
        $( 'body' ).addClass( 'mpf__show-form' );
      } );

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const numberOfPages = $( '.gform_page' ).length;
        if ( numberOfPages == currentPage ) {
          $( 'body' ).addClass( 'mpf__show-last-page-image' );
        } else {
          $( 'body' ).removeClass( 'mpf__show-last-page-image' );
        }
      } );

      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( 'body' ).addClass( 'mpf__is-confirmation' );
        $( 'body' ).removeClass( 'mpf__show-last-page-image' );
        $( '.gform_confirmation_message' ).addClass( 'wysiwyg theme-one' );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'multipage-form', COMPONENT );
} )( app );
